<div class="w-full relative flex items-center justify-center"
     [ngClass]="{'hidden': data == null}"
     style="height: 100vw; max-height: 500px"
     #chartContainer>
    <canvas #chartCanvas></canvas>
</div>

